export const PartnerTier = {
  FEATURED: 'featured',
  LOWER_MIDDLE: 'lower-middle',
  STANDARD: 'standard',
} as const;
export type PartnerTier = (typeof PartnerTier)[keyof typeof PartnerTier];

export class PartnerContext {
  private constructor(readonly tier: PartnerTier) {}

  static fromProfile(segment: string | null | undefined): PartnerContext {
    return new PartnerContext(
      segment === PartnerTier.FEATURED
        ? PartnerTier.FEATURED
        : PartnerTier.STANDARD,
    );
  }
}
